
import { webBasePath } from "./fetchConfigClient"
import { localStore, LocalStoreKeys } from "./store"


export async function getAuth() {
    let user = localStore.get(LocalStoreKeys.USER)
    return user
}


export function getCurrentAuth() {
    let user = localStore.get(LocalStoreKeys.USER)
    return user
}

export async function getAndCheckAuth() {
    let user = localStore.get(LocalStoreKeys.USER)
    // let userValid = checkAccessTokenValid(user.idToken);
    return user
}
 

function checkAccessTokenValid(accessToken: string) {
    const options = {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    };
    // 链接后端，用giteeTicket换用户信息；换uid和displayName
    fetch(`${webBasePath}/casdoor/validate/${accessToken}`, options)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        }).then((data) => {
            // console.log("gitee get user", data)
            let user = {
                idToken: data.idToken,
                uid: data.uid,
                type: "casdoor",
                displayName: data.displayName,
                getIdToken: async () => {
                    return data.idToken
                }
            }
            if (user) {
                saveUser(user)
            }
        })
}

// 定义缓存相关常量
const CACHE_KEY_REQUEST_FLAG = 'casdoorRequestStatus'; // 请求状态缓存键
const CACHE_KEY_RESULT = 'casdoorUserResult'; // 请求结果缓存键
const CACHE_EXPIRATION = 3600; // 缓存过期时间（秒）

export async function getUserByCasdoorCode(casdoorCode: string): Promise<any> {
    window.history.replaceState({ path: '/' }, '', '/'); 

    var protocol = window.location.protocol; // 获取协议部分，例如 "https:"
    var hostname = window.location.hostname; // 获取主机名部分，例如 "kimi.moonshot.cn"
    var port = window.location.port ? ':' + window.location.port : ''; // 获取端口部分，如果存在的话 
    var baseUrl = protocol + '//' + hostname + port;

    // 构造请求缓存的唯一标识，可以结合 giteeCode 和其他关键参数
    const cacheKey = `casdoorCode_${casdoorCode}`;
    // 先尝试从缓存获取结果
    const cachedResult = getCachedResult(cacheKey);
    if (cachedResult) {
        console.log('Return cached result');
        return cachedResult;
    }

    // 检查是否有请求正在进行
    if (isRequestPending(cacheKey)) {
        console.log('Request already in progress, ignore new request');
        return null; // 或者可以选择等待
    }

    // 标记请求为正在进行
    markRequestAsPending(cacheKey);

    try {
        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        };

        // 链接后端，用 giteeTicket 换用户信息；换 uid 和 displayName
        const user = await fetch(`${webBasePath}/casdoor/getUserInfo?code=${casdoorCode}&redirectUri=${baseUrl}`, options)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((result) => {
                let data = result.data;
                // console.log("casdoor get user", data)
                return {
                    idToken: data.idToken,
                    uid: data.uid,
                    type: "casdoor",
                    displayName: data.displayName,
                    email: data.email,
                };
            });

        if (user) {
            saveUser(user);
            // 缓存结果
            cacheResult(cacheKey, user);
            return user;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Request failed:', error);
        return null;
    } finally {
        // 请求完成后清除请求状态
        clearRequestStatus(cacheKey);
    }
}

// 从缓存获取结果
function getCachedResult(cacheKey: string): any {
    const cachedData = localStorage.getItem(`${CACHE_KEY_RESULT}_${cacheKey}`);
    if (!cachedData) return null;

    const data = JSON.parse(cachedData);
    const currentTime = Date.now();
    const expirationTime = data.timestamp + CACHE_EXPIRATION * 1000;

    // 检查缓存是否过期
    if (currentTime <= expirationTime) {
        return data.result;
    } else {
        // 缓存过期，删除缓存
        localStorage.removeItem(`${CACHE_KEY_RESULT}_${cacheKey}`);
        return null;
    }
}

// 缓存结果
function cacheResult(cacheKey: string, result: any): void {
    const dataToCache = {
        result: result,
        timestamp: Date.now()
    };
    localStorage.setItem(`${CACHE_KEY_RESULT}_${cacheKey}`, JSON.stringify(dataToCache));
}

// 检查是否有请求正在进行
function isRequestPending(cacheKey: string): boolean {
    const pendingStatus = localStorage.getItem(`${CACHE_KEY_REQUEST_FLAG}_${cacheKey}`);
    return pendingStatus === 'pending';
}

// 标记请求为正在进行
function markRequestAsPending(cacheKey: string): void {
    localStorage.setItem(`${CACHE_KEY_REQUEST_FLAG}_${cacheKey}`, 'pending');
}

// 清除请求状态
function clearRequestStatus(cacheKey: string): void {
    localStorage.removeItem(`${CACHE_KEY_REQUEST_FLAG}_${cacheKey}`);
}



export async function saveUser(user: any) {
    localStore.set(LocalStoreKeys.USER, user, 60*60*24)
}


export async function logout() {
    localStore.delete(LocalStoreKeys.USER)
}



export default {
    getAuth,
    saveUser,
    getUserByCasdoorCode,
    checkAccessTokenValid,
    getAndCheckAuth,
    getCurrentAuth,
    logout,
}